import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "lbl-error w-100"
}



export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorMsg',
  props: { 
 error:String
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.error)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.error), 1))
    : _createCommentVNode("", true)
}
}

})